export default __webpack_public_path__ + "static/media/next.d747e7e7.svg";